<template>
    <div>
        <v-progress-linear v-show="loading" active indeterminate height="2" absolute top color="muted" ></v-progress-linear>

        <div class="d-flex align-center mb-2">
            <div class="me-4">
                <v-chip small outlined>
                    جلسة #{{attempt.exam_session_id}}
                </v-chip>
                <v-chip small outlined>{{unitFormat(attempt.question_mark, 'درجة', 'درجتين', 'درجات')}}</v-chip>
            </div>

            <div class="d-flex align-center">
                <v-avatar size="25" style="box-shadow: 0 1px 4px rgb(0,0,0, .2)">
                    <img :src="attempt.user.avatar" />
                </v-avatar>
                <div class="text--text ms-2 details-text">{{attempt.user.name}}</div>
            </div>
        </div>
        <div class="py-3 mb-6">
            <div v-if="attempt.question.image_url" class="mb-4 bordered btn-radius overflow-hidden pa-3">
                <v-img :transition="false" contain :src="attempt.question.image_url" max-height="300" max-width="600" rounded v-ripple="{class: 'ripple--color'}" class="e-link"></v-img>
            </div>
            <div class="question-text strong-text--text" style="white-space: pre-line;font-size: 0.95rem; line-height: 1.8;">{{attempt.question.text}}</div>
        </div>

        <div class="mb-6">
            <v-textarea v-if="attempt.answer_text || !attempt.answer_image" label="إجابة الطالب" :value="attempt.answer_text" outlined readonly no-resize auto-grow rows="5" hide-details class="essay-textarea"></v-textarea>

            <v-img v-if="attempt.answer_image" :transition="false" :src="attempt.answer_image" width="300" class="answer-image-preview mt-3 e-link" v-ripple="{class: 'ripple--color'}" @click="openFullImageViewer"></v-img>
        </div>
        <div class="actions">
            <v-btn color="success" depressed class="px-5" :disabled="!!loading" :loading="loading === 'correct'" @click="submit(true)">
                <v-icon size="20" left>mdi-check-circle-outline</v-icon>
                إجابة صحيحة
            </v-btn>
            <v-btn color="error" depressed class="px-5 ms-2" :disabled="!!loading" :loading="loading === 'wrong'" @click="submit(false)">
                <v-icon size="20" left>mdi-close-circle-outline</v-icon>
                إجابة خاطئة
            </v-btn>
            <v-btn depressed class="px-5 ms-2" :disabled="!!loading" :loading="loading === 'correct'" @click="showManualMarkDialog = true;">
                <v-icon size="20" left>mdi-check-circle-outline</v-icon>
                أو إدخال الدرجة يدوياً
            </v-btn>
        </div>

        <v-dialog v-model="showManualMarkDialog" max-width="300" overlay-color="#000" overlay-opacity="0.8">
            <v-card>
                <v-card-title class="strong-text--text">
                    <v-icon color="primary" right>mdi-form-textbox</v-icon>
                    <span style="font-size: 17px;">إدخال درجة التصحيح يدوياً</span>
                </v-card-title>
                <v-card-subtitle></v-card-subtitle>
                <v-card-text>
                    <v-text-field v-model="manualMark" placeholder="أدخل الدرجة" hide-details min="0" :max="attempt.question_mark" type="number" outlined ></v-text-field>
                    <div class="mt-2">
                        <small class="muted--text">الدرجة الكاملة للسؤال : {{ unitFormat(attempt.question_mark, 'درجة', 'درجتين', 'درجات') }}</small>
                    </div>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer />
                    <v-btn text color="muted" @click="showManualMarkDialog = false;">إلغاء</v-btn>
                    <v-btn text color="primary" @click="submit(null, manualMark)" :loading="loading === 'manual'">حفظ الدرجة</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- full image viewer -->
        <img-viewer v-if="attempt && attempt.answer_image" :src="attempt.answer_image" @inited="photoViewerInited" />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import ImgViewer from '@/components/default/img-viewer'

export default {
    props: {
        attempt: {
            required: true,
        },
    },
    components: {ImgViewer},

    data(){
        return {
            loading: false,
            showManualMarkDialog: false,
            manualMark: '',

            $viewer: null,
        }
    },
    computed: {
        ...GlobalComputed,

    },

    methods: {
        ...GlobalMethods,

        submit(correct, manualMark=null){
            if (manualMark && manualMark > this.attempt.question_mark){
                this.showMsg('لا يمكن إضافة درجة تزيد عن الدرجة النهائية للسؤال', 'warning');
                return;
            }

            if (!this.loading){
                this.loading = manualMark ? 'manual' : (correct ? 'correct' : 'wrong');
                const id = this.attempt.id;
                const url = `/exams/attempts/${id}/correction`;

                let data = {};
                if (manualMark){
                    data.manual_correction_mark = manualMark;
                }else{
                    data.correct = correct;
                }

                this.$store.dispatch('fastPostAction', {url, data}).then(response=>{
                    this.showMsg('تم حفظ التصحيح بنجاح', 'success');

                    this.loading = false;
                    this.$emit('done', true);
                }).catch((e)=>{
                    this.loading = false;
                    const msg = e.response.message || 'حدثت مشكلة أثناء تنفيذ اﻹجراء';
                    this.showMsg(msg, 'error');
                })
            }
        },

        openFullImageViewer(){
            this.$viewer.show();
        },
        photoViewerInited(viewer) {
            this.$viewer = viewer;
        },
    }
}
</script>
<style lang="scss" scoped>
.answer-image-preview{
    border: 1px solid rgba(#000, 0.75);
}
</style>
